module.exports = __webpack_public_path__ + "img/tarjeta_sola.33e85d59.png";